import { Trans } from '@lingui/react/macro';
import type { UserPreferences } from '../../types/api';

interface SortOptionsProps {
  preferences: UserPreferences;
  onSortOrderToggle: () => void;
  showAppearanceOptions: boolean;
}

function SortOptions({ preferences, onSortOrderToggle }: SortOptionsProps) {
  return (
    <>
      {/* Sort Heading */}
      <div className="menu-header">
        <Trans>Sort</Trans>
      </div>

      {/* Sort Options */}
      <div className="flex flex-col">
        <button
          onClick={() =>
            preferences.bookmarkList.sortOrder !== 'newest' && onSortOrderToggle()
          }
          className="group menu-item justify-between"
        >
          <span>
            <Trans>Newest First</Trans>
          </span>
          {preferences.bookmarkList.sortOrder === 'newest' && (
            <svg
              className="text-copy-secondary group-hover:text-copy-primary h-2 w-2.5 fill-none stroke-current stroke-2"
              viewBox="0 0 9 8"
            >
              <path d="M1 4.31034L3.69231 7L8 1" />
            </svg>
          )}
        </button>
        <button
          onClick={() =>
            preferences.bookmarkList.sortOrder !== 'oldest' && onSortOrderToggle()
          }
          className="group menu-item justify-between"
        >
          <span>
            <Trans>Oldest First</Trans>
          </span>
          {preferences.bookmarkList.sortOrder === 'oldest' && (
            <svg
              className="text-copy-secondary group-hover:text-copy-primary h-2 w-2.5 fill-none stroke-current stroke-2"
              viewBox="0 0 9 8"
            >
              <path d="M1 4.31034L3.69231 7L8 1" />
            </svg>
          )}
        </button>
      </div>
    </>
  );
}

export default SortOptions;
